<template>
  <b-modal ref="modal">
    <div slot="modal-header" class="close-offset">
      <button class="close" type="button" aria-label="Close" @click="close()">×</button>
    </div>
    <iframe class="upload-iframe" src="https://precisionhealthreports.app.box.com/f/af465d1635f7436083ca4fa0989462e0"></iframe>
    <div slot="modal-footer"></div>
  </b-modal>
</template>

<script>
  import modalFormMixin from "mixins/modal-form-mixin";

export default {
  mixins: [modalFormMixin],

  data() {
    return {};
  },

  validations: {},

  methods: {
    close() {
      this.$refs.modal.hide();
    }
  }
};
</script>